import { ContractsService } from '@/services/contracts.service';
import { get } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getItemsList({ commit }, { params } = {}) {
    return ContractsService.getList({
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setContractsFilters', cloneDeep(params.filters));
      commit(
        'setContractsPaginationOptions',
        cloneDeep(params.paginationOptions)
      );

      return response;
    });
  },

  getBillingPeriods({ commit }) {
    return ContractsService.getBillingPeriods().then(response => {
      return response;
    });
  },

  getPayableWithin({ commit }) {
    return ContractsService.getPayableWithin().then(response => {
      return response;
    });
  },

  getServicesFilterList(_, params) {
    return get(`/contracts/filters/abo-services`, params);
  }
};
